// Generated by ReScript, PLEASE EDIT WITH CARE


function mediaMax(bound) {
  return "(max-width: " + String(bound - 1 | 0) + "px)";
}

function mediaMin(bound) {
  return "(min-width: " + String(bound) + "px)";
}

function mediaRange(bound1, bound2) {
  var mx = bound1 > bound2 ? bound1 : bound2;
  var mn = bound1 < bound2 ? bound1 : bound2;
  return "" + mediaMax(mx) + " and " + mediaMin(mn) + "";
}

function mediaMaxHeight(bound) {
  return "(max-height: " + String(bound - 1 | 0) + "px)";
}

function mediaMinHeight(bound) {
  return "(max-height: " + String(bound - 1 | 0) + "px)";
}

function mediaOr(range1, range2) {
  return "" + range1 + ", " + range2 + "";
}

var mobile = mediaMax(425);

var mobileUp = mediaMin(425);

var tabletSm = mediaMax(690);

var tabletSmUp = mediaMin(690);

var mobileOrTabletSm = mediaRange(425, 690);

var tabletSmOrTablet = mediaRange(690, 1024);

var tabletOrDesktop = mediaMin(425);

var tablet = mediaRange(425, 1024);

var desktop = mediaMin(1024);

var tabletOrMobile = mediaMax(1024);

var smallScreen = mediaRange(425, 768);

var smallScreenOrMobile = mediaMax(768);

var largeScreen = mediaMin(1288);

var belowLargeScreen = mediaMax(1288);

var tabletToLargeScreen = mediaRange(425, 1288);

var mobile$1 = mediaMax(690);

var tabletOrDesktop$1 = mediaMin(690);

var tablet$1 = mediaRange(690, 1288);

var desktop$1 = mediaMin(1288);

var tabletOrMobile$1 = mediaMax(1288);

var CategoryTiles = {
  mobileBreakpoint: 690,
  mobile: mobile$1,
  tabletOrDesktop: tabletOrDesktop$1,
  tablet: tablet$1,
  desktop: desktop$1,
  tabletOrMobile: tabletOrMobile$1
};

var mobileBreakpoint = 425;

var tabletSmBreakpoint = 690;

var smallScreenBreakpoint = 768;

var tabletBreakpoint = 1024;

var largeScreenBreakpoint = 1288;

export {
  mobileBreakpoint ,
  tabletSmBreakpoint ,
  smallScreenBreakpoint ,
  tabletBreakpoint ,
  largeScreenBreakpoint ,
  mediaMax ,
  mediaMin ,
  mediaRange ,
  mediaMaxHeight ,
  mediaMinHeight ,
  mediaOr ,
  mobile ,
  mobileUp ,
  tabletSm ,
  tabletSmUp ,
  mobileOrTabletSm ,
  tabletSmOrTablet ,
  tabletOrDesktop ,
  tablet ,
  desktop ,
  tabletOrMobile ,
  smallScreen ,
  smallScreenOrMobile ,
  largeScreen ,
  belowLargeScreen ,
  tabletToLargeScreen ,
  CategoryTiles ,
}
/* mobile Not a pure module */
